export default [
  {
    header: 'Anagrafica',
    resource: 'anagrafica',
    action: 'read',
  },
  {
    title: 'Anagrafica Unica',
    icon: 'UserIcon',
    route: 'visualizza-anagrafica',
    resource: 'anagrafica',
    action: 'read',
  },
  {
    title: 'Storico Soggetto',
    icon: 'UserIcon',
    route: 'storico-soggetto',
    resource: 'anagrafica',
    action: 'read',
  },

]
